import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';

import {
  selectTrackingPageNumbers,
  selectFirstTrackingPageNumber,
  selectShowDetails,
  selectSidebarItems,
  selectOpenedSidebarItems,
  selectSelectedTrackingNumber,
  isLoadMoreTrackingNumbersVisible,
  selectMoreTrackingNumberValues,
  selectLoading,
  selectShowDetailsLoading,
  selectCheckpoints
} from './tracking-page-numbers.selectors';
import { OrderCardNumber } from './tracking-page-number.model';
import {
  selectIsLoadMoreVisible,
  selectShowMoreValues
} from './tracking-page-numbers.selectors';
import {
  OpenTrackingNumberDetails,
  CloseTrackingNumberDetails,
  OpenSidebarItem,
  CloseSidebarItem,
  SelectTrackingNumber,
  UpdateReview,
  ShowMore,
  LoadMoreTrackingNumbers,
  CloseAllTrackingNumberDetails,
  FetchSidebarItems
} from './tracking-page-numbers.actions';

@Injectable()
export class TrackingPageNumbersFacade {
  constructor(private store: Store<any>) {}

  public readonly all$ = this.store.pipe(select(selectTrackingPageNumbers));

  public readonly showDetails$ = this.store.pipe(select(selectShowDetails));

  public readonly showDetailsLoading$ = this.store.pipe(
    select(selectShowDetailsLoading)
  );

  public readonly isLoadMoreVisible$ = this.store.pipe(
    select(selectIsLoadMoreVisible)
  );

  readonly loading$ = this.store.pipe(select(selectLoading));

  public readonly moreValues$ = this.store.pipe(select(selectShowMoreValues));

  public readonly firstTrackingNumber$: Observable<OrderCardNumber> =
    this.store.pipe(select(selectFirstTrackingPageNumber));

  public readonly sideBarItems$: Observable<any[]> = this.store.pipe(
    select(selectSidebarItems)
  );

  public readonly sideBarItemsOpened$: Observable<any[]> = this.store.pipe(
    select(selectOpenedSidebarItems)
  );

  public readonly selectedTrackingNumber$: Observable<any> = this.store.pipe(
    select(selectSelectedTrackingNumber)
  );

  public readonly isLoadMoreTrackingNumbersVisible$: Observable<boolean> =
    this.store.pipe(select(isLoadMoreTrackingNumbersVisible));

  public readonly moreTrackingNumberValues$: Observable<number> =
    this.store.pipe(select(selectMoreTrackingNumberValues));

  public readonly checkpoints$ = this.store.pipe(select(selectCheckpoints));

  openDetails(id: string, orderId: string) {
    this.store.dispatch(new OpenTrackingNumberDetails({ id, orderId }));
  }

  closeDetails(id: string) {
    this.store.dispatch(new CloseTrackingNumberDetails(id));
  }

  closeAllDetails() {
    this.store.dispatch(new CloseAllTrackingNumberDetails());
  }

  openSidebarItem(id: any) {
    this.store.dispatch(new OpenSidebarItem(id));
  }

  closeSidebarItem(id: any) {
    this.store.dispatch(new CloseSidebarItem(id));
  }

  selectTrackingNumber(id) {
    this.store.dispatch(new SelectTrackingNumber(id));
  }

  updateReview(data) {
    this.store.dispatch(new UpdateReview(data));
  }

  fetchSidebarItems(params = {}) {
    this.store.dispatch(new FetchSidebarItems(params));
  }

  showMore() {
    this.store.dispatch(new ShowMore());
  }

  loadMoreTrackingNumbers() {
    this.store.dispatch(new LoadMoreTrackingNumbers());
  }
}
